import { useWebSocket } from "WebSocketContext";
import { useGameContext } from "GameContext";
import { HIGHLIGHTS } from "utils/ToolTipConst";

import {
  useState,
  useRef,
  useEffect,
} from "react";

import { getRoleConstants } from "utils/game-information-constants";

export default function Stockbreeder() {
  const { socket } = useWebSocket();
  const {
    playerInfo,
    connectedIds,
    changeInHerdEvent,
    roleGroups,


    minDebt,
    selfRoleMoney,
  } = useGameContext() as any;

  const roleGroup = roleGroups[`${playerInfo?.estate}-${playerInfo?.role}`]
  const initialHerd = roleGroup?.herdSize ?? 0;
  const stockbreederConstants = getRoleConstants("Stockbreeder", "public") ?? ({} as Record<string, any>);
  const animalValue = stockbreederConstants?.animalValue ?? 600;
  const animalProductivity = stockbreederConstants?.animalProductivity ?? 400;
  const feedCost = stockbreederConstants?.feedCost ?? 0;
  const staticCosts = stockbreederConstants?.staticCosts ?? [];

  useEffect(() => {
    if (changeInHerdEvent?.quantity !== undefined && amount !== changeInHerdEvent.quantity) {
      amountRef.current = changeInHerdEvent?.quantity;
      setAmount(changeInHerdEvent.quantity);
    }
  }, [changeInHerdEvent?.quantity])

  const amountRef = useRef(0);
  const [amount, setAmount] = useState(0);
  const newHerd = initialHerd + amount


  function buy() {
    const cowCost = animalValue
    if (roleGroup?.money - (amount * cowCost) < minDebt) {
      alert(`Your projected revenue reached the debt limit of ${minDebt}`);
      return
    }
    amountRef.current += 1
    setAmount(amountRef.current);
    changeHerd();
    // setAmount((prev) => prev + 1)
  }

  function sell() {
    if (newHerd === 0) {
      return
    }
    amountRef.current -= 1
    setAmount(amountRef.current);
    changeHerd();
    // setAmount((prev) => prev - 1)
  }

  // useEffect(() => {
  //   changeHerd();
  // }, [amount])

  function onMessage(event: { data: string }) {
    if (event.data) {
      const message = JSON.parse(event.data);
      if (message.kind === "UpdateChangeInHerd") {
        setAmount(message.changeInHerdEvent.quantity);
      }
    }
  }

  function changeHerd() {
    const changeEvent = {
      authordId: playerInfo.id,
      authorRole: "Stockbreeder",
      authorEstate: "public",
      quantity: amountRef.current,
    }

    socket?.send(JSON.stringify({
      kind: "UpdateChangeInHerd",
      toIds: connectedIds,
      changeInHerdEvent: changeEvent,
    }))
  }

  return (
    <div className="flex flex-col gap-2">
      <p className="font-semibold underline">Animal husbantry:</p>
      <p>This year's starting Herd Size : {initialHerd}</p>
      <p>New Herd Size : {newHerd}</p>
      <p>New Cow Cost : {amount * animalValue}</p>
      <br/>
      <p>Each cow produces ${animalProductivity} every year</p>
      <p>Cost of a cow : ${animalValue}</p>
      <br/>
      <p>Must feed animals if they cannot graze on land. Fodder costs ${getRoleConstants("Stockbreeder", "public")?.feedCost} per animal per season of missing pastoral value</p>
      <br/>
      <p>Projected cattle gross income : <br/>

        <span className={HIGHLIGHTS.positive}>${newHerd * (getRoleConstants("Stockbreeder", "public")?.animalProductivity ?? 400)}</span></p>
      <br/>
      <p>Projected Fodder Cost (w/o grazing) : <br/>
        <span className={HIGHLIGHTS.negative}>${feedCost * newHerd * 4}</span></p>
      <br/>                  
      <p>Farm upkeep costs : <br/>
        <span className={HIGHLIGHTS.negative}>${staticCosts?.[0]?.[0] ?? 0}</span></p> 
      <p>Farm laborer salaries : <br/>
        <span className={HIGHLIGHTS.negative}>${staticCosts?.[1]?.[0] ?? 0}</span></p>
      <br/>
      <button className="bg-[#BCB7A8] border-black border rounded-full w-full py-1" onClick={buy}>Buy</button>
      <button className="bg-[#BCB7A8] border-black border rounded-full w-full py-1" onClick={sell}>Sell</button>

      { changeInHerdEvent?.quantity !== undefined && changeInHerdEvent?.quantity !== 0 && (
        <div className="border border-black rounded p-2 bg-[#BCB7A8]">
          <p className="text-center">Changes in Herd</p>
          <p>{changeInHerdEvent?.quantity > 0 ? (
            `Purchased ${changeInHerdEvent?.quantity} cows for $${animalValue * changeInHerdEvent?.quantity}`
          ) : (
            `Sold ${Math.abs(changeInHerdEvent?.quantity ?? 0)} cows for $${animalValue * -(changeInHerdEvent?.quantity ?? 0)}`
          )}</p>
        </div>
      )}
    </div>
  )

}
